<iim-card [header]="supplierHeader" [footer]="supplierFooter">
    <ng-template #supplierHeader>
        <div class="px-2">
            <div class="row">
                <div class="col">
                    <h3>
                        <em class="fas fa-dolly pe-2"></em>
                        {{ 'Lieferanten' | translate }}
                    </h3>
                </div>
            </div>
        </div>
    </ng-template>
    <div class="px-3">
        @if (currencyCheckPending) {
            <div class="alert alert-info" data-cy="SUPPLIER_CURRENCY_CHECK_PENDING">
                <em class="fas fa-hourglass-half pe-1"></em>
                {{ 'Die Währungsprüfung läuft noch – die Freigabe als Bestellung ist so lange gesperrt.' | translate }}
            </div>
        }
        @if (currencyConflictMessage) {
            <div class="alert alert-danger" data-cy="SUPPLIER_CURRENCY_CONFLICT">
                <em class="fas fa-triangle-exclamation pe-1"></em>
                {{ currencyConflictMessage }}
            </div>
        }
        @if (currencyCheckErrorMessage) {
            <div class="alert alert-warning" data-cy="SUPPLIER_CURRENCY_CHECK_ERROR">
                <em class="fas fa-triangle-exclamation pe-1"></em>
                {{ currencyCheckErrorMessage }}
                <button
                    type="button"
                    class="btn btn-sm btn-outline-dark ms-2"
                    (click)="currencyCheckRetry.emit()"
                    data-cy="RETRY_SUPPLIER_CURRENCY_CHECK"
                >
                    {{ 'Erneut prüfen' | translate }}
                </button>
            </div>
        }
        @if (suppliers?.length) {
            <ul class="list-group">
                @for (supplier of suppliers; track supplier) {
                    <li class="list-group-item px-2 py-1" [class.supplier-no-email]="!hasEmail(supplier)">
                        <div class="px-3">
                            @if (supplier.hasIncotermDeviation) {
                                <div class="alert alert-warning mt-2" role="alert">
                                    <em class="fas fa-exclamation-triangle pe-2"></em>
                                    {{
                                        'Der gewählte Incoterm „{{ selected }}“ weicht vom Standard-Incoterm „{{ standard }}“ des Lieferanten ab.'
                                            | translate
                                                : {
                                                      selected: supplier.effectiveIncotermCode,
                                                      standard: supplier.defaultIncotermCode,
                                                  }
                                    }}
                                </div>
                            }
                            <div class="row">
                                <div class="col pe-0">
                                    <div class="row">
                                        <div class="col">
                                            <div class="row flex-nowrap">
                                                <div class="col pt-1">
                                                    <h6>{{ supplier.displayName }}</h6>
                                                </div>
                                                @if (!readonly && supplierChangeAllowed) {
                                                    <div class="col-auto">
                                                        <button
                                                            [matTooltip]="'Ansprechpartner wechseln' | translate"
                                                            mat-icon-button
                                                            (click)="openChangeContactDialog(supplier)"
                                                            data-cy="CHANGE_SUPPLIER_CONTACT"
                                                        >
                                                            <em class="fas fa-user-pen"></em>
                                                        </button>
                                                    </div>
                                                    <div class="col-auto">
                                                        <button
                                                            [matTooltip]="'Lieferant entfernen' | translate"
                                                            mat-icon-button
                                                            color="warn"
                                                            (click)="removeSupplier(supplier)"
                                                        >
                                                            <em class="fas fa-trash"></em>
                                                        </button>
                                                    </div>
                                                }
                                            </div>
                                            @if (supplier.email) {
                                                <a href="mailTo:{{ supplier.email }}" target="_blank">
                                                    {{ supplier.email }}
                                                </a>
                                                <br />
                                            }
                                            <div *showOnDebug>
                                                <strong>ID</strong>
                                                :
                                                <span copyToClipboard>{{ supplier.companyId.value }}</span>
                                            </div>
                                            <strong>{{ 'Ansprechpartner' | translate }}:</strong>
                                            @if (supplier.contact) {
                                                {{
                                                    supplier.contact
                                                        | person
                                                        | supplierContactName: supplier.hasDefaultContact
                                                }}
                                            } @else {
                                                {{ 'Kein Ansprechpartner hinterlegt' | translate }}
                                            }
                                        </div>
                                    </div>
                                    <div class="row mt-2">
                                        <div class="col p-0">
                                            <demand-supplier-delivery-condition
                                                [editable]="!readonly"
                                                [condition]="supplier.deliveryCondition"
                                                [demandId]="demandId"
                                                [supplierCompanyId]="supplier.companyId.value"
                                            ></demand-supplier-delivery-condition>
                                        </div>
                                    </div>
                                    <div class="row mt-2">
                                        <div class="col p-0">
                                            <demand-supplier-payment-term
                                                [editable]="!readonly"
                                                [paymentTerm]="supplier.paymentTerm"
                                                [paymentTermRequired]="supplier.paymentTermRequired"
                                                [demandId]="demandId"
                                                [supplierCompanyId]="supplier.companyId.value"
                                                [companyCodeId]="companyCodeId"
                                                (deleted)="paymentTermDeleted(supplier)"
                                                (updated)="paymentTermUpdated(supplier, $event)"
                                            ></demand-supplier-payment-term>
                                        </div>
                                    </div>

                                    <div class="row mt-2">
                                        <div class="col p-0">
                                            <demand-supplier-incoterm
                                                [editable]="!readonly"
                                                [incotermCode]="supplier.incotermCode"
                                                [defaultIncotermCode]="supplier.defaultIncotermCode"
                                                [demandId]="demandId"
                                                [supplierCompanyId]="supplier.companyId.value"
                                                (updated)="incotermUpdated(supplier, $event)"
                                            ></demand-supplier-incoterm>
                                        </div>
                                    </div>

                                    <div class="row mt-2">
                                        <div class="col p-0">
                                            <demand-supplier-framework-agreement
                                                [editable]="!readonly"
                                                [frameworkAgreement]="supplier.supplierFrameworkAgreement"
                                                [demandId]="demandId"
                                                [supplierCompanyId]="supplier.companyId.value"
                                                (deleted)="onDeleteSupplierFrameworkAgreement(supplier)"
                                                (updated)="OnUpdateSupplierFrameworkAgreement(supplier, $event)"
                                            ></demand-supplier-framework-agreement>
                                        </div>
                                    </div>

                                    @if (supplier.orderingNote) {
                                        <div class="row mt-2">
                                            <div class="col">
                                                <div class="alert alert-info">
                                                    <em class="fas fa-info-circle"></em>
                                                    {{ supplier.orderingNote }}
                                                </div>
                                            </div>
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>
                    </li>
                }
            </ul>
        }
        @if (suppliers?.length === 0) {
            <div class="alert" [ngClass]="{ 'alert-danger': required && !isValid, 'alert-info': !required || isValid }">
                @if (!readonly && supplierChangeAllowed) {
                    <span>
                        {{ 'Es wurden noch keine Lieferanten ausgewählt' | translate }}
                    </span>
                }
                @if (readonly || !supplierChangeAllowed) {
                    <span>
                        {{ 'Es wurden keine Lieferanten ausgewählt' | translate }}
                    </span>
                }
            </div>
        }
    </div>
    <ng-template #supplierFooter>
        @if (!readonly && supplierChangeAllowed) {
            <div class="col">
                <div class="row justify-content-center">
                    <div class="col-auto">
                        <button class="btn btn-outline-dark" (click)="openSupplierSelection()" data-cy="ADD_SUPPLIER">
                            <em class="fas fa-plus fa-1_5xx"></em>
                        </button>
                    </div>
                </div>
            </div>
        }
    </ng-template>
</iim-card>
